module.exports = __webpack_public_path__ + "img/78584cc.jpg";